import { User, Company, Role } from '@adsk/alloy-provider';

export interface Pagination {
  limit: number;
  offset: number;
  totalResults: number;
}

/**
 * The Autodesk id of the user
 * @export
 * @type OxygenId
 */
export type OxygenId = string;
export type RfiId = string;
export type DateRange = string;

export type OxygenRole = Omit<
  Role & {
    /** @deprecated 'type' should be used */
    oxygenType: AssigneeType.Role;
    type: AssigneeType.Role;
    /** @deprecated 'memberCount' should be used */
    isInProject: boolean;
    memberCount: number;
    oxygenId: Role['memberGroupId'];
    serverId: Role['id'];
    id: Role['memberGroupId'];
  },
  'memberGroupId'
>;

export type OxygenCompany = Omit<
  Company & {
    /** @deprecated 'type' should be used */
    oxygenType: AssigneeType.Company;
    type: AssigneeType.Company;
    oxygenId: Company['memberGroupId'];
    serverId: Company['id'];
    id: Company['memberGroupId'];
  },
  'memberGroupId'
>;

export type OxygenUser = Omit<
  Omit<User, 'roles'> & {
    /** @deprecated 'type' should be used */
    oxygenType: AssigneeType.User;
    type: AssigneeType.User;
    dbId: User['id'];
    id: User['autodeskId'];
    oxygenId: User['autodeskId'];
    company: {
      id: User['companyId'];
      oxygenId: Company['memberGroupId'] | OxygenCompany['oxygenId'];
      name: Company['name'];
    };
    roles: Array<{
      id: Role['memberGroupId'] | OxygenRole['oxygenId'];
      oxygenId: Role['memberGroupId'] | OxygenRole['oxygenId'];
    }>;
    rolesMap: User['roleIds'];
    profileImg50: User['imageUrl'];
  },
  'roleIds'
>;

export type OxygenEntity = OxygenUser | OxygenCompany | OxygenRole;

export enum EntityStatus {
  Active = 'active',
  Inactive = 'inactive',
  Hidden = 'hidden',
  Deleted = 'deleted',
  Pending = 'pending',
  Disabled = 'disabled',
  NotInvited = 'not_invited',
}
export enum AssigneeType {
  User = 'user',
  Role = 'role',
  Company = 'company',
}

export type Assignee = {
  id: OxygenId;
  type: AssigneeType;
};
